var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c(
        "md-card",
        { staticClass: "mt-20" },
        [
          _c(
            "md-card-content",
            {
              staticClass: "ask-subject",
              class: { "request-status-bar": this.selectedOwner },
              style: { padding: "9px" }
            },
            [
              _c(
                "div",
                { staticClass: "card-inline ask-status-bar" },
                [
                  _c("div", [
                    _c("p", {
                      staticClass: "ask-status",
                      domProps: { textContent: _vm._s(_vm.getStatus) }
                    }),
                    _vm._v(" "),
                    _vm.ask.favorite
                      ? _c("span", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn custom-card-header-filter btn-transparent btn:focus",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.favoriteRequest(
                                    _vm.ask._id,
                                    "unfavorite"
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "bottom" } },
                                [_vm._v("unfavorite")]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-star fa-lg gold-color",
                                attrs: { "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ])
                      : _c("span", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn custom-card-header-filter btn-transparent btn:focus",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.favoriteRequest(
                                    _vm.ask._id,
                                    "favorite"
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "bottom" } },
                                [_vm._v("favorite")]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "far fa-star fa-lg",
                                attrs: { "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "list-inline align-right btnleftspaceremove owner-li"
                      },
                      [
                        _vm.ask.status != "(7) Closed" &&
                        _vm.ask.status != "(8) Rejected"
                          ? _c(
                              "li",
                              { staticClass: "w-30" },
                              [
                                _c(
                                  "md-field",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "md-select",
                                      {
                                        staticClass: "owner-select",
                                        attrs: {
                                          name: "owner",
                                          id: "owner",
                                          placeholder: "Owner"
                                        },
                                        model: {
                                          value: _vm.selectedOwner,
                                          callback: function($$v) {
                                            _vm.selectedOwner = $$v
                                          },
                                          expression: "selectedOwner"
                                        }
                                      },
                                      [
                                        _c(
                                          "md-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("Owner (none)")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.allOwners, function(
                                          singleOwner
                                        ) {
                                          return _c(
                                            "md-option",
                                            {
                                              key: singleOwner._id,
                                              attrs: {
                                                value: singleOwner.email
                                              }
                                            },
                                            [_vm._v(_vm._s(singleOwner.email))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.availableInteractions, function(action) {
                          return _c(
                            "li",
                            { key: action, attrs: { interaction: action } },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-round md-accent capitalize",
                                  class:
                                    action === "coach" ? "new-coach-btn" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.doInteraction(action)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(action))]
                              )
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _vm.getStatus === "Add Tags"
                          ? _c(
                              "li",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent capitalize",
                                    on: {
                                      click: function($event) {
                                        return _vm.saveTag()
                                      }
                                    }
                                  },
                                  [_vm._v("Add Tags")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.escalateBtn == true
                          ? _c(
                              "li",
                              { staticClass: "pl-0" },
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent capitalize",
                                    staticStyle: {
                                      "background-color": "#F2C057"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showDialog = true
                                      }
                                    }
                                  },
                                  [_vm._v("Request Support")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getStatus === "Pending"
                          ? _c(
                              "li",
                              [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round capitalize capitalize request-status-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.doInteraction("approve")
                                      }
                                    }
                                  },
                                  [_vm._v("Super Admin Approval")]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-dialog",
                    {
                      staticClass: "request-support",
                      attrs: { "md-active": _vm.showDialog },
                      on: {
                        "update:mdActive": function($event) {
                          _vm.showDialog = $event
                        },
                        "update:md-active": function($event) {
                          _vm.showDialog = $event
                        }
                      }
                    },
                    [
                      _c("md-dialog-title", [_vm._v("Request Support")]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Message")]),
                          _vm._v(" "),
                          _c("md-textarea", {
                            attrs: { maxlength: "1000", "md-counter": "1000" },
                            on: { input: _vm.sanitizeRequestSupport },
                            model: {
                              value: _vm.requestSupportMsg,
                              callback: function($$v) {
                                _vm.requestSupportMsg = $$v
                              },
                              expression: "requestSupportMsg"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-dialog-actions",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.cancelRequestSupport()
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-primary md-save",
                                attrs: {
                                  disabled: _vm.requestSupportMsg.length == 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.requestSupportSubmit()
                                  }
                                }
                              },
                              [_vm._v("Submit")]
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-dialog",
                    {
                      staticClass: "coach-box",
                      attrs: { "md-active": _vm.coachDialog },
                      on: {
                        "update:mdActive": function($event) {
                          _vm.coachDialog = $event
                        },
                        "update:md-active": function($event) {
                          _vm.coachDialog = $event
                        }
                      }
                    },
                    [
                      _c("md-dialog-title", [_vm._v("Coach")]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Message")]),
                          _vm._v(" "),
                          _c("md-textarea", {
                            attrs: { "md-autogrow": "" },
                            on: { input: _vm.sanitizeCoachMsg },
                            model: {
                              value: _vm.coachMsg,
                              callback: function($$v) {
                                _vm.coachMsg = $$v
                              },
                              expression: "coachMsg"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-dialog-actions",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary",
                              on: {
                                click: function($event) {
                                  return _vm.cancelCoach()
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-primary md-save",
                                attrs: { disabled: _vm.coachMsg.length == 0 },
                                on: {
                                  click: function($event) {
                                    return _vm.coachSubmit()
                                  }
                                }
                              },
                              [_vm._v("Submit")]
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-dialog",
                    {
                      staticClass: "admin-request-approve",
                      attrs: { "md-active": _vm.AdminApprovalDialog },
                      on: {
                        "update:mdActive": function($event) {
                          _vm.AdminApprovalDialog = $event
                        },
                        "update:md-active": function($event) {
                          _vm.AdminApprovalDialog = $event
                        }
                      }
                    },
                    [
                      _c("md-dialog-title", [
                        _vm._v("Are you sure you want to approve this request?")
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-dialog-actions",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary yes-btn",
                              on: {
                                click: function($event) {
                                  return _vm.AdminApproval()
                                }
                              }
                            },
                            [_vm._v("Yes")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary no-btn",
                              on: {
                                click: function($event) {
                                  _vm.AdminApprovalDialog = false
                                }
                              }
                            },
                            [_vm._v("No")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-header",
            { staticClass: "ask-subject", style: _vm.communityStyle },
            [
              _c("ul", { staticClass: "list-inline mb-0" }, [
                _c("li", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$lodash.has(_vm.community, "name")
                          ? _vm.community.name +
                              ": " +
                              (_vm.ask.subject ? _vm.ask.subject : "N/A")
                          : _vm.ask.subject
                          ? _vm.ask.subject
                          : "N/A"
                      ) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _vm.ask.matchingCriteria &&
                  _vm.ask.matchingCriteria.assignment &&
                  _vm.ask.matchingCriteria.assignment.autoRefill === true
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "vertical-align": "middle",
                            "margin-left": "6px"
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticStyle: { "vertical-align": "middle" },
                              attrs: {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                fill: "#004D40"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticStyle: { "margin-left": "15px" } },
                  [
                    _vm._l(_vm.ask.stars, function(star) {
                      return [_vm._v("★")]
                    }),
                    _vm._v(" "),
                    _vm.ask.deadline
                      ? _c(
                          "span",
                          {
                            staticStyle: { "margin-left": "15px" },
                            style:
                              _vm.$moment(_vm.ask.deadline) < _vm.$moment()
                                ? "text-decoration:line-through"
                                : ""
                          },
                          [
                            _vm._v(
                              "Deadline:\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.tinyDate(_vm.ask.deadline))
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.ask.comments && _vm.ask.comments.length
                  ? _c("li", { staticClass: "count" }, [
                      _vm._v(_vm._s(_vm.ask.comments.length))
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ask-detail", {
        staticClass: "mt-30",
        attrs: {
          ask: _vm.ask,
          community: _vm.community,
          feedbacks: _vm.feedbacks,
          editAsk: "true"
        }
      }),
      _vm._v(" "),
      _c("approval-guidance-card", {
        ref: "approvalGuidance",
        staticClass: "mt-30",
        attrs: { evaluation: _vm.analysis, "request-text": _vm.ask.text || "" },
        on: {
          generate: _vm.handleGenerateEvaluation,
          "scroll-to-responses": _vm.openAndScrollToResponses
        }
      }),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-header",
            {
              staticClass: "md-title m-left-5",
              attrs: { "md-alignment": "space-between" }
            },
            [_vm._v("Request")]
          ),
          _vm._v(" "),
          _c("md-card-content", { staticClass: "card-content" }, [
            _c(
              "form",
              [
                _c(
                  "md-field",
                  { staticClass: "create-ask m-left-5" },
                  [
                    _c("label", { staticClass: "card-header" }, [
                      _vm._v("Subject")
                    ]),
                    _vm._v(" "),
                    _c("md-input", {
                      attrs: {
                        name: "subject",
                        placeholder: "Request summary..."
                      },
                      on: {
                        input: _vm.sanitizeSubject,
                        change: function($event) {
                          return _vm.saveAskContent("subject")
                        }
                      },
                      model: {
                        value: _vm.ask.subject,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.ask,
                            "subject",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "ask.subject"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "create-ask ask-description-area form-group m-left-5"
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "card-header",
                        attrs: { for: "textarea" }
                      },
                      [_vm._v("Description")]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.formattedText,
                          expression: "formattedText",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass:
                        "form-control description remove-box-shadow font-16",
                      attrs: {
                        rows: "14",
                        id: "textarea",
                        placeholder: "Describe the request..."
                      },
                      domProps: { value: _vm.formattedText },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.formattedText = $event.target.value.trim()
                          },
                          _vm.sanitizeDescription
                        ],
                        change: function($event) {
                          return _vm.saveAskContent("description")
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c("md-button", { staticClass: "expand-button-size" }, [
                        _c(
                          "strong",
                          {
                            staticClass: "upper-word",
                            on: {
                              click: function($event) {
                                return _vm.expand("tag")
                              }
                            }
                          },
                          [
                            _vm._v("Tags\n\t\t\t\t\t\t\t"),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  "(" +
                                    (_vm.$lodash.has(_vm.ask.tags, 0)
                                      ? _vm.ask.tags.length
                                      : "0") +
                                    ")"
                                )
                              }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "inline-flex",
                        "align-items": "center",
                        gap: "4px",
                        "font-size": "11px",
                        color: "#6366f1",
                        cursor: "pointer",
                        "margin-right": "16px",
                        "font-weight": "normal",
                        opacity: "1",
                        transition: "opacity 0.2s"
                      },
                      style: {
                        opacity: _vm.athenaLoading ? 0.6 : 1,
                        cursor: _vm.athenaLoading ? "not-allowed" : "pointer"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.athenaLoading
                            ? null
                            : _vm.handleGenerateEvaluation()
                        }
                      }
                    },
                    [
                      _c(
                        "md-icon",
                        {
                          style: {
                            color: "#6366f1",
                            fontSize: "14px !important",
                            animation: _vm.athenaLoading
                              ? "spin 1s linear infinite"
                              : "none",
                            verticalAlign: "middle"
                          }
                        },
                        [_vm._v("autorenew")]
                      ),
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.athenaLoading
                              ? "Analyzing..."
                              : "Re-run Analysis"
                          ) +
                          "\n\t\t\t\t\t"
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c(
                    "md-card-content",
                    { staticClass: "card-content md-scrollbar scrollbar" },
                    [
                      _vm.opened.includes("tag")
                        ? [
                            _vm.ask.tags.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "flex-box tag-vertical-scroll"
                                  },
                                  [
                                    _vm._l(_vm.ask.tags, function(tag) {
                                      return [
                                        _c(
                                          "md-chip",
                                          {
                                            key: tag,
                                            staticClass:
                                              "flex-child md-style-chip",
                                            attrs: { "md-deletable": "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeTag(tag)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(tag))]
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.addTags.apply(null, arguments)
                                  }
                                }
                              },
                              [
                                _c(
                                  "md-field",
                                  { staticClass: "m-left-10" },
                                  [
                                    _c("md-input", {
                                      attrs: { placeholder: "Add tag..." },
                                      on: { input: _vm.sanitizeTags },
                                      model: {
                                        value: _vm.tags,
                                        callback: function($$v) {
                                          _vm.tags = $$v
                                        },
                                        expression: "tags"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.adviserMatchSection === true
        ? _c(
            "md-card",
            {
              staticClass: "mt-30 adviser-section",
              attrs: { id: "adviser-match-section" }
            },
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "expand-button-size" },
                            [
                              _c(
                                "strong",
                                {
                                  staticClass: "upper-word",
                                  on: {
                                    click: function($event) {
                                      return _vm.expand("adviser-match")
                                    }
                                  }
                                },
                                [
                                  _vm._v("Advisers "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        "(" + _vm.matchedAdvisors.length + ")"
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _vm.opened.includes("adviser-match")
                        ? _c(
                            "md-card-content",
                            { staticClass: "card-content" },
                            [
                              _vm.matchedAdvisors.length
                                ? _c(
                                    "md-table",
                                    { staticClass: "ask-response-table" },
                                    [
                                      _c(
                                        "md-table-row",
                                        [
                                          _c("md-table-head", {
                                            staticClass:
                                              "card-header remove-table-head-margin minus-icon-remove-margin"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Name")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Score")]),
                                              _vm._v("\n\t\t\t\t\t\t\t\t "),
                                              _vm.currentMatchedSortScore ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "asc",
                                                          "score"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentMatchedSortScore ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "desc",
                                                          "score"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Freq")]),
                                              _vm._v("\n\t\t\t\t\t\t\t\t "),
                                              _vm.currentMatchedSortFreq ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "asc",
                                                          "frequency"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentMatchedSortFreq ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "desc",
                                                          "frequency"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Last Request Rec'd")
                                              ]),
                                              _vm._v("\n\t\t\t\t\t\t\t\t "),
                                              _vm.currentMatchedSortLastReqRec ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "asc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentMatchedSortLastReqRec ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "desc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Response")]),
                                              _vm._v("\n\t\t\t\t\t\t\t "),
                                              _vm.currentMatchedSortLastResponse ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "asc",
                                                          "last_response"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentMatchedSortLastResponse ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "desc",
                                                          "last_response"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Email")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Status")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Action")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.matchedAdvisors, function(
                                        matchedAdvisor,
                                        index
                                      ) {
                                        return matchedAdvisor._id !==
                                          _vm.ask.createdByMemberID &&
                                          _vm.matchedAdvisors.length
                                          ? [
                                              _c(
                                                "md-table-row",
                                                {
                                                  key: matchedAdvisor._id,
                                                  staticClass:
                                                    "response-section",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.expandAdviserSection(
                                                        matchedAdvisor._id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "md-table-cell",
                                                    {
                                                      staticClass:
                                                        "minus-icon-remove-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-mini md-fab btnplain",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeFromMatchedAdviser(
                                                                matchedAdvisor,
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "picker-icon-danger font-24",
                                                              attrs: {
                                                                icon:
                                                                  "minus-circle"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  matchedAdvisor &&
                                                  matchedAdvisor._id
                                                    ? _c("md-table-cell", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "display-link",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.goToProfile(
                                                                  matchedAdvisor._id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                matchedAdvisor.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        matchedAdvisor.score +
                                                          "%"
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.frequency
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            matchedAdvisor.frequency
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("W")
                                                      ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.last_request
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              matchedAdvisor.last_request
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.last_response
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              matchedAdvisor.last_response
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getAdviserSectionStatus(
                                                          matchedAdvisor._id
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        matchedAdvisor.eventData
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor &&
                                                  matchedAdvisor._id
                                                    ? _c("md-table-cell", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "display-link display-resend-link",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.resendEmail(
                                                                  matchedAdvisor._id,
                                                                  matchedAdvisor.email,
                                                                  _vm.$route
                                                                    .params
                                                                    .ask_id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Resend")]
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.expandAdviser.includes(
                                                matchedAdvisor._id
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "adviser-row-" + index,
                                                      staticClass: "table-row"
                                                    },
                                                    [
                                                      _c(
                                                        "md-table-cell",
                                                        {
                                                          attrs: {
                                                            colspan: "10"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-4"
                                                                },
                                                                [
                                                                  matchedAdvisor.linkedIn
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "m-left-10 mt-20"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "display-link",
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.goToLinkedInProfile(
                                                                                        matchedAdvisor.linkedIn
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.linkedIn
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          matchedAdvisor.role
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.role
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          matchedAdvisor.organization
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      ", " +
                                                                                        matchedAdvisor.organization
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          matchedAdvisor.city
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.city
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          matchedAdvisor.state
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      ", " +
                                                                                        matchedAdvisor.state
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-8"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      matchedAdvisor.school1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.school1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.department1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.department1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.major1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.major1
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.major2
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.major2
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.major3
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.major3
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.year1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.year1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          matchedAdvisor.bio
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "bio1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "md-body-1 light bio-paragraph"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          matchedAdvisor.bio
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-box"
                                                                },
                                                                _vm._l(
                                                                  matchedAdvisor.skills,
                                                                  function(
                                                                    skill,
                                                                    idx
                                                                  ) {
                                                                    return skill
                                                                      ? _c(
                                                                          "md-chip",
                                                                          {
                                                                            key:
                                                                              skill +
                                                                              idx,
                                                                            staticClass:
                                                                              "flex-child",
                                                                            attrs: {
                                                                              "md-disabled":
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                skill
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "search-addon-btnstyle md-button md-accent card-header md-theme-default",
                                      attrs: {
                                        disabled:
                                          _vm.searchAdvisors.trim().length <
                                            3 ==
                                          1,
                                        title: "Search",
                                        "aria-label": "Search advisors"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getAllAdvList()
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-search" })]
                                  ),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "searchAdvisor",
                                      placeholder: "Search advisors..."
                                    },
                                    on: {
                                      input: _vm.sanitizeSearchAdvisors,
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        _vm.searchAdvisors.trim().length >= 3
                                          ? _vm.getAllAdvList()
                                          : ""
                                      }
                                    },
                                    model: {
                                      value: _vm.searchAdvisors,
                                      callback: function($$v) {
                                        _vm.searchAdvisors = $$v
                                      },
                                      expression: "searchAdvisors"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.suggestedAdvisors.length
                                ? _c(
                                    "md-table",
                                    {
                                      staticClass:
                                        "ask-response-table margin-top-20"
                                    },
                                    [
                                      _c(
                                        "md-table-row",
                                        [
                                          _c("md-table-head", {
                                            staticClass:
                                              "card-header remove-table-head-margin plus-icon-remove-margin"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Name")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Score")]),
                                              _vm._v("\n\t\t\t\t\t\t\t\t "),
                                              _vm.newCurrentSuggestedSortScore ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "asc",
                                                          "score"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.newCurrentSuggestedSortScore ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "desc",
                                                          "score"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Community")]),
                                              _vm._v("\n\t\t\t\t\t\t\t "),
                                              _vm.newCurrentSuggestedSortCommunity ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "asc",
                                                          "community"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.newCurrentSuggestedSortCommunity ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "desc",
                                                          "community"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.suggestedAdvisorType ==
                                            "volunteer" ||
                                          _vm.suggestedAdvisorType == "vip"
                                            ? _c(
                                                "md-table-head",
                                                {
                                                  staticClass:
                                                    "card-header remove-table-head-margin"
                                                },
                                                [
                                                  _c("span", [_vm._v("Type")]),
                                                  _vm._v("\n\t\t\t\t\t\t\t "),
                                                  _vm.newCurrentSuggestedSortMemberRank ===
                                                  "desc"
                                                    ? _c("font-awesome-icon", {
                                                        staticClass:
                                                          "selector font-24 float-right",
                                                        attrs: {
                                                          icon: "caret-down"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.sortSuggestedAdviser(
                                                              "asc",
                                                              "member_rank"
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.newCurrentSuggestedSortMemberRank ===
                                                  "asc"
                                                    ? _c("font-awesome-icon", {
                                                        staticClass:
                                                          "selector font-24 float-right",
                                                        attrs: {
                                                          icon: "caret-up"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.sortSuggestedAdviser(
                                                              "desc",
                                                              "member_rank"
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [_vm._v("Freq")]),
                                              _vm._v("\n\t\t\t\t\t\t\t "),
                                              _vm.newCurrentSuggestedSortFreq ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "asc",
                                                          "frequency"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.newCurrentSuggestedSortFreq ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "desc",
                                                          "frequency"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(" Request Rec'd")
                                              ]),
                                              _vm._v("\n\t\t\t\t\t\t\t "),
                                              _vm.newCurrentSuggestedSortLastReqRec ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "asc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.newCurrentSuggestedSortLastReqRec ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "desc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(" Response ")
                                              ]),
                                              _vm._v("\n\t\t\t\t\t\t\t "),
                                              _vm.newCurrentSuggestedSortLastResponse ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "asc",
                                                          "last_response"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.newCurrentSuggestedSortLastResponse ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortSuggestedAdviser(
                                                          "desc",
                                                          "last_response"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.suggestedAdvisors, function(
                                        suggestedAdvisor,
                                        index
                                      ) {
                                        return [
                                          index < _vm.showSuggestedAdviser
                                            ? _c(
                                                "md-table-row",
                                                {
                                                  key: suggestedAdvisor._id,
                                                  staticClass:
                                                    "response-section",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.expandSuggestedAdviserSection(
                                                        suggestedAdvisor._id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "md-table-cell",
                                                    {
                                                      staticClass:
                                                        "plus-icon-remove-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-mini md-fab btnplain",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.addToMatchedAdviser(
                                                                suggestedAdvisor,
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "picker-icon font-24",
                                                              attrs: {
                                                                icon:
                                                                  "plus-circle"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  suggestedAdvisor &&
                                                  suggestedAdvisor._id
                                                    ? _c("md-table-cell", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "display-link",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.goToProfile(
                                                                  suggestedAdvisor._id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                suggestedAdvisor.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        suggestedAdvisor.score +
                                                          "%"
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        suggestedAdvisor.community
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  (_vm.suggestedAdvisorType ==
                                                    "volunteer" ||
                                                    _vm.suggestedAdvisorType ==
                                                      "vip") &&
                                                  suggestedAdvisor.member_rank &&
                                                  suggestedAdvisor.member_rank
                                                    .length
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            suggestedAdvisor.member_rank.toString()
                                                          )
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  suggestedAdvisor.frequency
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            suggestedAdvisor.frequency
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("W")
                                                      ]),
                                                  _vm._v(" "),
                                                  suggestedAdvisor.last_request
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              suggestedAdvisor.last_request
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  suggestedAdvisor.last_response
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              suggestedAdvisor.last_response
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.expandSuggestedAdviser.includes(
                                            suggestedAdvisor._id
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  key:
                                                    "suggested-adviser-row-" +
                                                    index,
                                                  staticClass: "table-row"
                                                },
                                                [
                                                  _c(
                                                    "md-table-cell",
                                                    {
                                                      attrs: { colspan: "10" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-4"
                                                            },
                                                            [
                                                              suggestedAdvisor.linkedIn
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "display-link",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.goToLinkedInProfile(
                                                                                  suggestedAdvisor.linkedIn
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.linkedIn
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-10 mt-20"
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    suggestedAdvisor.role
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.role
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    suggestedAdvisor.organization
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                ", " +
                                                                                  suggestedAdvisor.organization
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("div", [
                                                                    suggestedAdvisor.city
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.city
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    suggestedAdvisor.state
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                ", " +
                                                                                  suggestedAdvisor.state
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-8"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-10 mt-20"
                                                                },
                                                                [
                                                                  suggestedAdvisor.school1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.school1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.department1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.department1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.major1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.major1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.major2
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t        " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.major2
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t      "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.major3
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t        " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.major3
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t      "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.year1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.year1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      suggestedAdvisor.bio
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bio1"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "md-body-1 light bio-paragraph"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      suggestedAdvisor.bio
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex-box"
                                                            },
                                                            _vm._l(
                                                              suggestedAdvisor.skills,
                                                              function(
                                                                skill,
                                                                idx
                                                              ) {
                                                                return skill
                                                                  ? _c(
                                                                      "md-chip",
                                                                      {
                                                                        key:
                                                                          skill +
                                                                          idx,
                                                                        staticClass:
                                                                          "flex-child",
                                                                        attrs: {
                                                                          "md-disabled":
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            skill
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row mt-20 bottom-loadMore" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-xs-6 text-right"
                                    },
                                    [
                                      _vm.suggestedAdvisors.length >
                                      _vm.showSuggestedAdviser
                                        ? _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-mini btnplain capitalize card-header",
                                              on: {
                                                click: function($event) {
                                                  _vm.showSuggestedAdviser += 5
                                                }
                                              }
                                            },
                                            [_vm._v("Load More")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-xs-6 text-right"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "match-dropdown" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-28" },
                                            [
                                              _c(
                                                "md-field",
                                                [
                                                  _c(
                                                    "md-select",
                                                    {
                                                      attrs: {
                                                        name: "matchAdvisor",
                                                        placeholder:
                                                          "Select match option"
                                                      },
                                                      on: {
                                                        "md-closed": function(
                                                          $event
                                                        ) {
                                                          return _vm.selectMatchAdvser()
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.suggestedAdvisorType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.suggestedAdvisorType = $$v
                                                        },
                                                        expression:
                                                          "suggestedAdvisorType"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "acceptedResponse"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match Acpt. Resp."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "AllMatch"
                                                          }
                                                        },
                                                        [_vm._v("Match All")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "matchNoRequest"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match No-Request"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "vip"
                                                          }
                                                        },
                                                        [_vm._v("Match VIP")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "volunteer"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match Volunteers"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.pageCount != 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "text-right theme-pagination"
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "list-inline align-right mtm-3"
                                        },
                                        [
                                          _c("li", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group goToPage"
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v("Go to page:")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.page,
                                                        expression: "page"
                                                      }
                                                    ],
                                                    attrs: {
                                                      name: "page_number",
                                                      id: "page_number"
                                                    },
                                                    on: {
                                                      change: [
                                                        function($event) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.page = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        },
                                                        function($event) {
                                                          return _vm.goToPage()
                                                        }
                                                      ]
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.pageCount,
                                                    function(n) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: n,
                                                          domProps: { value: n }
                                                        },
                                                        [_vm._v(_vm._s(n))]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            [
                                              _c("paginate", {
                                                attrs: {
                                                  "page-count": _vm.pageCount,
                                                  "page-range": 3,
                                                  "margin-pages": 2,
                                                  "click-handler":
                                                    _vm.matchAdviserList,
                                                  "prev-text": "Prev",
                                                  "next-text": "Next",
                                                  "container-class":
                                                    "pagination",
                                                  "page-class": "page-item"
                                                },
                                                model: {
                                                  value: _vm.page,
                                                  callback: function($$v) {
                                                    _vm.page = $$v
                                                  },
                                                  expression: "page"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-mini md-fab btnplain refreshBtn",
                                                  attrs: { title: "Refresh" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.refreshBtn()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../assets/refresh.png")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.adviserMatchSection === false
        ? _c(
            "md-card",
            { staticClass: "mt-30 adviser-section" },
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "expand-button-size" },
                            [
                              _c(
                                "strong",
                                {
                                  staticClass: "upper-word",
                                  on: {
                                    click: function($event) {
                                      return _vm.expand("adviser")
                                    }
                                  }
                                },
                                [
                                  _vm._v("Advisers "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.ask.recommendedAdvisors
                                          ? "(" +
                                              _vm.ask.recommendedAdvisors
                                                .length +
                                              ")"
                                          : "(0)"
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/gemini-match/" + _vm.ask._id,
                                    target: "_new"
                                  }
                                },
                                [_vm._v("Gemini")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _vm.opened.includes("adviser")
                        ? _c(
                            "md-card-content",
                            { staticClass: "card-content" },
                            [
                              _vm.matchedAdvisors.length
                                ? _c(
                                    "md-table",
                                    { staticClass: "ask-response-table" },
                                    [
                                      _c(
                                        "md-table-row",
                                        [
                                          _c("md-table-head", {
                                            staticClass:
                                              "card-header remove-table-head-margin minus-icon-remove-margin"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Name")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_c("span", [_vm._v("Freq")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Last Request Rec'd")
                                              ]),
                                              _vm._v("\n\t\t\t\t\t\t\t\t "),
                                              _vm.currentMatchedSortLastReqRec ===
                                              "desc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: {
                                                      icon: "caret-down"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "asc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentMatchedSortLastReqRec ===
                                              "asc"
                                                ? _c("font-awesome-icon", {
                                                    staticClass:
                                                      "selector font-24 float-right",
                                                    attrs: { icon: "caret-up" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sortMatchedAdviser(
                                                          "desc",
                                                          "last_request"
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_c("span", [_vm._v("Response")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Email")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Status")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Action")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.matchedAdvisors, function(
                                        matchedAdvisor,
                                        index
                                      ) {
                                        return matchedAdvisor._id !==
                                          _vm.ask.createdByMemberID &&
                                          _vm.matchedAdvisors.length
                                          ? [
                                              _c(
                                                "md-table-row",
                                                {
                                                  key: matchedAdvisor._id,
                                                  staticClass:
                                                    "response-section",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.expandAdviserSection(
                                                        matchedAdvisor._id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "md-table-cell",
                                                    {
                                                      staticClass:
                                                        "minus-icon-remove-margin"
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-mini md-fab btnplain",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeFromMatchedAdviser(
                                                                matchedAdvisor,
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "picker-icon-danger font-24",
                                                              attrs: {
                                                                icon:
                                                                  "minus-circle"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  matchedAdvisor &&
                                                  matchedAdvisor._id
                                                    ? _c("md-table-cell", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "display-link",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.goToProfile(
                                                                  matchedAdvisor._id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                matchedAdvisor.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.frequency
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            matchedAdvisor.frequency
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("W")
                                                      ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.last_request
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              matchedAdvisor.last_request
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor.last_response
                                                    ? _c("md-table-cell", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "momentDate"
                                                            )(
                                                              matchedAdvisor.last_response
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("md-table-cell", [
                                                        _vm._v("N/A")
                                                      ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getAdviserSectionStatus(
                                                          matchedAdvisor._id
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        matchedAdvisor.eventData
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  matchedAdvisor &&
                                                  matchedAdvisor._id
                                                    ? _c("md-table-cell", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "display-link display-resend-link",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.resendEmail(
                                                                  matchedAdvisor._id,
                                                                  matchedAdvisor.email,
                                                                  _vm.$route
                                                                    .params
                                                                    .ask_id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Resend")]
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.expandAdviser.includes(
                                                matchedAdvisor._id
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "adviser-row-" + index,
                                                      staticClass: "table-row"
                                                    },
                                                    [
                                                      _c(
                                                        "md-table-cell",
                                                        {
                                                          attrs: {
                                                            colspan: "10"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-4"
                                                                },
                                                                [
                                                                  matchedAdvisor.linkedIn
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "m-left-10 mt-20"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "display-link",
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.goToLinkedInProfile(
                                                                                        matchedAdvisor.linkedIn
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.linkedIn
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          matchedAdvisor.role
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.role
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          matchedAdvisor.organization
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      ", " +
                                                                                        matchedAdvisor.organization
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          matchedAdvisor.city
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      matchedAdvisor.city
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          matchedAdvisor.state
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      ", " +
                                                                                        matchedAdvisor.state
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-sm-8"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      matchedAdvisor.school1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.school1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.department1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.department1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.major1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.major1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      matchedAdvisor.year1
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                                  _vm._s(
                                                                                    matchedAdvisor.year1
                                                                                  ) +
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          matchedAdvisor.bio
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "bio1"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "md-body-1 light bio-paragraph"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          matchedAdvisor.bio
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-box"
                                                                },
                                                                _vm._l(
                                                                  matchedAdvisor.skills,
                                                                  function(
                                                                    skill,
                                                                    idx
                                                                  ) {
                                                                    return skill
                                                                      ? _c(
                                                                          "md-chip",
                                                                          {
                                                                            key:
                                                                              skill +
                                                                              idx,
                                                                            staticClass:
                                                                              "flex-child",
                                                                            attrs: {
                                                                              "md-disabled":
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                skill
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "search-addon-btnstyle md-button md-accent card-header md-theme-default",
                                      attrs: {
                                        disabled:
                                          _vm.searchAdvisors.trim().length <
                                            3 ==
                                          1,
                                        title: "Search",
                                        "aria-label": "Search advisors"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getAllAdvList()
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-search" })]
                                  ),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "searchAdvisor",
                                      placeholder: "Search advisors..."
                                    },
                                    on: {
                                      input: _vm.sanitizeSearchAdvisors,
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        _vm.searchAdvisors.trim().length >= 3
                                          ? _vm.getAllAdvList()
                                          : ""
                                      }
                                    },
                                    model: {
                                      value: _vm.searchAdvisors,
                                      callback: function($$v) {
                                        _vm.searchAdvisors = $$v
                                      },
                                      expression: "searchAdvisors"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.suggestedAdvisors.length
                                ? _c(
                                    "md-table",
                                    {
                                      staticClass:
                                        "ask-response-table margin-top-20"
                                    },
                                    [
                                      _c(
                                        "md-table-row",
                                        [
                                          _c("md-table-head", {
                                            staticClass:
                                              "card-header remove-table-head-margin plus-icon-remove-margin"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_vm._v("Name")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_c("span", [_vm._v("Community")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_c("span", [_vm._v("Freq")])]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(" Request Rec'd")
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header remove-table-head-margin"
                                            },
                                            [_c("span", [_vm._v(" Response ")])]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.suggestedAdvisors, function(
                                        suggestedAdvisor,
                                        index
                                      ) {
                                        return [
                                          _c(
                                            "md-table-row",
                                            {
                                              key: suggestedAdvisor._id,
                                              staticClass: "response-section",
                                              on: {
                                                click: function($event) {
                                                  return _vm.expandSuggestedAdviserSection(
                                                    suggestedAdvisor._id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "md-table-cell",
                                                {
                                                  staticClass:
                                                    "plus-icon-remove-margin"
                                                },
                                                [
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-mini md-fab btnplain",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addToMatchedAdviser(
                                                            suggestedAdvisor,
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass:
                                                          "picker-icon font-24",
                                                        attrs: {
                                                          icon: "plus-circle"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              suggestedAdvisor &&
                                              suggestedAdvisor._id
                                                ? _c("md-table-cell", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "display-link",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.goToProfile(
                                                              suggestedAdvisor._id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            suggestedAdvisor.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _c("md-table-cell", [
                                                    _vm._v("N/A")
                                                  ]),
                                              _vm._v(" "),
                                              _c("md-table-cell", [
                                                _vm._v(
                                                  _vm._s(
                                                    suggestedAdvisor.community
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              suggestedAdvisor.frequency
                                                ? _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        suggestedAdvisor.frequency
                                                      )
                                                    )
                                                  ])
                                                : _c("md-table-cell", [
                                                    _vm._v("W")
                                                  ]),
                                              _vm._v(" "),
                                              suggestedAdvisor.last_request
                                                ? _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("momentDate")(
                                                          suggestedAdvisor.last_request
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("md-table-cell", [
                                                    _vm._v("N/A")
                                                  ]),
                                              _vm._v(" "),
                                              suggestedAdvisor.last_response
                                                ? _c("md-table-cell", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("momentDate")(
                                                          suggestedAdvisor.last_response
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("md-table-cell", [
                                                    _vm._v("N/A")
                                                  ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.expandSuggestedAdviser.includes(
                                            suggestedAdvisor._id
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  key:
                                                    "suggested-adviser-row-" +
                                                    index,
                                                  staticClass: "table-row"
                                                },
                                                [
                                                  _c(
                                                    "md-table-cell",
                                                    {
                                                      attrs: { colspan: "10" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-4"
                                                            },
                                                            [
                                                              suggestedAdvisor.linkedIn
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "m-left-10 mt-20"
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "display-link",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.goToLinkedInProfile(
                                                                                  suggestedAdvisor.linkedIn
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.linkedIn
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-10 mt-20"
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    suggestedAdvisor.role
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.role
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    suggestedAdvisor.organization
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                ", " +
                                                                                  suggestedAdvisor.organization
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("div", [
                                                                    suggestedAdvisor.city
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                suggestedAdvisor.city
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    suggestedAdvisor.state
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                ", " +
                                                                                  suggestedAdvisor.state
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-sm-8"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-left-10 mt-20"
                                                                },
                                                                [
                                                                  suggestedAdvisor.school1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.school1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.department1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.department1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.major1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.major1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  suggestedAdvisor.year1
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t                " +
                                                                              _vm._s(
                                                                                suggestedAdvisor.year1
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      suggestedAdvisor.bio
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bio1"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "md-body-1 light bio-paragraph"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      suggestedAdvisor.bio
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex-box"
                                                            },
                                                            _vm._l(
                                                              suggestedAdvisor.skills,
                                                              function(
                                                                skill,
                                                                idx
                                                              ) {
                                                                return _c(
                                                                  "md-chip",
                                                                  {
                                                                    key:
                                                                      skill +
                                                                      idx,
                                                                    staticClass:
                                                                      "flex-child",
                                                                    attrs: {
                                                                      "md-disabled":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        skill
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row mt-20 bottom-loadMore" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-xs-6 text-right"
                                    },
                                    [
                                      _vm.sugAdvSkip + _vm.sugAdvLimit <
                                      _vm.sugAdvCount
                                        ? _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-mini btnplain capitalize card-header",
                                              on: {
                                                click: function($event) {
                                                  return _vm.sugAdvData(
                                                    "loadMore"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Load More")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-xs-6 text-right"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "match-dropdown" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-28" },
                                            [
                                              _c(
                                                "md-field",
                                                [
                                                  _c(
                                                    "md-select",
                                                    {
                                                      attrs: {
                                                        name: "matchAdvisor",
                                                        placeholder:
                                                          "Select match option"
                                                      },
                                                      on: {
                                                        "md-closed": function(
                                                          $event
                                                        ) {
                                                          return _vm.selectMatchAdvser()
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.suggestedAdvisorType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.suggestedAdvisorType = $$v
                                                        },
                                                        expression:
                                                          "suggestedAdvisorType"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "acceptedResponse"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match Acpt. Resp."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "AllMatch"
                                                          }
                                                        },
                                                        [_vm._v("Match All")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "matchNoRequest"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match No-Request"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "vip"
                                                          }
                                                        },
                                                        [_vm._v("Match VIP")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-option",
                                                        {
                                                          attrs: {
                                                            value: "volunteer"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Match Volunteers"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30", attrs: { id: "response-section" } },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        {
                          ref: "responseExpandBtn",
                          staticClass: "expand-button-size",
                          on: {
                            click: function($event) {
                              return _vm.expand("response")
                            }
                          }
                        },
                        [
                          _c("strong", { staticClass: "upper-word" }, [
                            _vm._v("Responses\n\t\t\t\t\t\t\t\t"),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  "(" + _vm.responseSectionCount + ")"
                                )
                              }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c(
                    "md-card-content",
                    { staticClass: "card-content md-scrollbar scrollbar" },
                    [
                      _c(
                        "md-table",
                        { staticClass: "ask-response-table" },
                        [
                          _c(
                            "md-table-row",
                            [
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Name")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Email")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Community")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Responded")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Status")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Action")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Sent")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-table-head",
                                {
                                  staticClass:
                                    "card-header remove-table-head-margin"
                                },
                                [_vm._v("Response Evaluation")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.sortResponses, function(give, index) {
                            return [
                              _c(
                                "md-table-row",
                                {
                                  key: give._id,
                                  staticClass: "response-section",
                                  on: {
                                    click: function($event) {
                                      _vm.expandResponseSection(give._id)
                                      _vm.giveId = give._id
                                    }
                                  }
                                },
                                [
                                  give.advisors && give.advisors.length
                                    ? _c("md-table-cell", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "display-link",
                                            on: {
                                              click: function($event) {
                                                _vm.goToProfile(
                                                  String(
                                                    give.advisors[0]._id ||
                                                      give.advisors[0]
                                                  )
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.getAdviserDetails(
                                                    "name",
                                                    String(
                                                      give.advisors[0]._id ||
                                                        give.advisors[0]
                                                    )
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("md-table-cell", [_vm._v("N/A")]),
                                  _vm._v(" "),
                                  _c("md-table-cell", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          give.advisors && give.advisors.length
                                            ? _vm.getAdviserDetails(
                                                "email",
                                                String(
                                                  give.advisors[0]._id ||
                                                    give.advisors[0]
                                                )
                                              )
                                            : give.email
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  give.advisors && give.advisors.length
                                    ? _c("md-table-cell", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.community
                                              ? _vm.community.name
                                              : "N/A"
                                          )
                                        )
                                      ])
                                    : _c("md-table-cell", [_vm._v("N/A")]),
                                  _vm._v(" "),
                                  _c("md-table-cell", [
                                    _vm._v(
                                      _vm._s(_vm._f("momentDate")(give.when))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  give.responseState &&
                                  give.responseState.currentState
                                    ? _c(
                                        "md-table-cell",
                                        {
                                          class: [
                                            {
                                              "md-orange-color": [
                                                "In Review",
                                                "Pending"
                                              ].includes(
                                                give.responseState.currentState
                                              )
                                            },
                                            {
                                              "md-green-color":
                                                give.responseState
                                                  .currentState === "Approved"
                                            },
                                            {
                                              "md-red-color":
                                                give.responseState
                                                  .currentState === "Rejected"
                                            },
                                            {
                                              "md-yellow-color":
                                                give.giveType &&
                                                give.giveType === "referred"
                                            },
                                            {
                                              "md-blue-color":
                                                give.giveType &&
                                                give.giveType === "snoozed"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              give.giveType &&
                                                give.giveType === "referred"
                                                ? "Referred"
                                                : give.responseState &&
                                                  give.responseState
                                                    .currentState
                                                ? give.responseState
                                                    .currentState
                                                : "N/A"
                                            )
                                          )
                                        ]
                                      )
                                    : _c("md-table-cell", [_vm._v("N/A")]),
                                  _vm._v(" "),
                                  give.action
                                    ? _c("md-table-cell", [
                                        _vm._v(_vm._s(give.action))
                                      ])
                                    : _c("md-table-cell", [_vm._v("N/A")]),
                                  _vm._v(" "),
                                  _c("md-table-cell", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          give.advisors && give.advisors.length
                                            ? _vm.getAdviserDetails(
                                                "request-date",
                                                String(
                                                  give.advisors[0]._id ||
                                                    give.advisors[0]
                                                ),
                                                give._id
                                              )
                                            : "N/A"
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  give.responseState &&
                                  give.responseState.currentState === "Pending"
                                    ? _c("md-table-cell", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "button",
                                            attrs: {
                                              href:
                                                "/update-response-status/?askid=" +
                                                _vm.ask._id +
                                                "&giveid=" +
                                                give._id +
                                                "&status=approve&type=response&communityId=" +
                                                _vm.community._id,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("Approve")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  give.responseEvaluation &&
                                  give.responseEvaluation.recommended
                                    ? _c("md-table-cell", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "eval-badge",
                                            class: {
                                              "eval-pass":
                                                _vm.getStatusLabel(
                                                  give.responseEvaluation
                                                ) === "PASS",
                                              "eval-caution":
                                                _vm.getStatusLabel(
                                                  give.responseEvaluation
                                                ) === "CAUTION",
                                              "eval-fail":
                                                _vm.getStatusLabel(
                                                  give.responseEvaluation
                                                ) === "FAIL"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openEvalModal(give)
                                              }
                                            }
                                          },
                                          [
                                            _vm.getStatusLabel(
                                              give.responseEvaluation
                                            ) === "PASS"
                                              ? _c("span", [_vm._v("✔")])
                                              : _vm.getStatusLabel(
                                                  give.responseEvaluation
                                                ) === "CAUTION"
                                              ? _c("span", [_vm._v("⚠")])
                                              : _c("span", [_vm._v("✕")]),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.getStatusLabel(
                                                    give.responseEvaluation
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("md-table-cell", [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "eval-badge",
                                            staticStyle: {
                                              background: "#f0f0f0",
                                              color: "#666"
                                            },
                                            attrs: {
                                              disabled:
                                                _vm.evaluatingGiveId ===
                                                give._id
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.generateEvaluation(
                                                  give
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.evaluatingGiveId ===
                                                    give._id
                                                    ? "Evaluating..."
                                                    : "Evaluate"
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.expandResponse.includes(give._id)
                                ? _c(
                                    "div",
                                    {
                                      key: "give-expand-" + give._id,
                                      staticClass: "table-row mt-20"
                                    },
                                    [
                                      (give.helpaction != "no" &&
                                        give.responseState &&
                                        give.responseState.currentState ===
                                          "In Review") ||
                                      (give.helpaction != "no" &&
                                        give.responseState.currentState ===
                                          "Rejected")
                                        ? _c(
                                            "md-table-cell",
                                            { attrs: { colspan: "8" } },
                                            [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value: give.insight,
                                                    expression: "give.insight",
                                                    modifiers: { trim: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "response-description",
                                                attrs: {
                                                  id: "response-id-" + index,
                                                  "data-id":
                                                    "response-id-" + index
                                                },
                                                domProps: {
                                                  value: give.insight
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.editResponse(
                                                      _vm.ask._id,
                                                      give
                                                    )
                                                  },
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        give,
                                                        "insight",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.sanitizeInsight(
                                                        $event,
                                                        give
                                                      )
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              give.helpaction != "no"
                                                ? _c(
                                                    "md-card-actions",
                                                    {
                                                      staticClass:
                                                        "card-actions"
                                                    },
                                                    _vm._l(
                                                      give.responseState
                                                        .availableStates,
                                                      function(action) {
                                                        return _c(
                                                          "md-button",
                                                          {
                                                            key: action,
                                                            class: [
                                                              {
                                                                "md-orange":
                                                                  action ===
                                                                  "Reject"
                                                              },
                                                              "md-raised",
                                                              "md-accent",
                                                              "md-round",
                                                              "float-right",
                                                              "capitalize",
                                                              "md-white-color",
                                                              "m-left-10"
                                                            ],
                                                            attrs: {
                                                              interaction: action
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.responseActions(
                                                                  _vm.ask._id,
                                                                  give._id,
                                                                  action
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(action) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : give.helpaction != "no" &&
                                          give.responseState &&
                                          give.responseState.currentState ===
                                            "Approved"
                                        ? _c(
                                            "md-table-cell",
                                            { attrs: { colspan: "8" } },
                                            [
                                              give.action &&
                                              [
                                                "Share Advice",
                                                "Insight",
                                                "Call Me"
                                              ].includes(give.action)
                                                ? [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "ask-response-description"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(give.insight)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "w-100 response-section-padding"
                                                },
                                                [
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-raised md-accent md-round capitalize md-white-color float-left",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sendFeedbackToMember(
                                                            give
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Get Feedback")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-raised md-accent md-round capitalize md-white-color float-left m-left-10",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.sendResponseToMember(
                                                            give
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Send Response")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              !give.followUp
                                                ? _c(
                                                    "div",
                                                    { staticClass: "plr20" },
                                                    [
                                                      [
                                                        _c("h4", [
                                                          _vm._v(
                                                            "Add Follow-up manually"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "md-radio",
                                                          {
                                                            attrs: {
                                                              name:
                                                                "followType" +
                                                                index,
                                                              id:
                                                                "followType-" +
                                                                index,
                                                              "data-id":
                                                                "followType-" +
                                                                index,
                                                              value: "yes"
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.folloUpType(
                                                                  "yes",
                                                                  index
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.followType[
                                                                  index
                                                                ],
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.followType,
                                                                  index,
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "followType[index]"
                                                            }
                                                          },
                                                          [_vm._v("Yes")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "md-radio",
                                                          {
                                                            attrs: {
                                                              name:
                                                                "followType" +
                                                                index,
                                                              id:
                                                                "followType-" +
                                                                index,
                                                              "data-id":
                                                                "followType-" +
                                                                index,
                                                              value: "no"
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.folloUpType(
                                                                  "no",
                                                                  index
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.followType[
                                                                  index
                                                                ],
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.followType,
                                                                  index,
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "followType[index]"
                                                            }
                                                          },
                                                          [_vm._v("No")]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.followType[index] ==
                                                        "no"
                                                          ? _c("div", {}, [
                                                              _c("textarea", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model.trim",
                                                                    value:
                                                                      _vm
                                                                        .followUpMessage[
                                                                        index
                                                                      ],
                                                                    expression:
                                                                      "followUpMessage[index]",
                                                                    modifiers: {
                                                                      trim: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "response-description font-16",
                                                                attrs: {
                                                                  rows: "5",
                                                                  id:
                                                                    "followMsg-" +
                                                                    index,
                                                                  "data-id":
                                                                    "followMsg-" +
                                                                    index,
                                                                  name:
                                                                    "followUpMessage" +
                                                                    index,
                                                                  placeholder:
                                                                    "I have not followed up because ..."
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .followUpMessage[
                                                                      index
                                                                    ]
                                                                },
                                                                on: {
                                                                  input: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.followUpMessage,
                                                                        index,
                                                                        $event.target.value.trim()
                                                                      )
                                                                    },
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.sanitizeFollowUpMessage(
                                                                        $event,
                                                                        index
                                                                      )
                                                                    }
                                                                  ],
                                                                  blur: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  }
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _vm.followType[
                                                                index
                                                              ] &&
                                                              !_vm
                                                                .followUpMessage[
                                                                index
                                                              ]
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "error"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Please enter\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tyour response follow-up reason"
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.followType[index]
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "md-button",
                                                                  {
                                                                    staticClass:
                                                                      "md-raised md-accent md-round capitalize md-white-color float-left",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.submitFollowUp(
                                                                          give,
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Submit"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ask-manual-response" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "create-ask m-left-10 response-head1"
                            },
                            [_vm._v("Add Manual Response")]
                          ),
                          _vm._v(" "),
                          _c("show-adviser", {
                            staticClass: "m-left-10 mt-10",
                            attrs: { iconName: "Search adviser" },
                            on: { chosen: _vm.addAdvisors }
                          }),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.addManualResponse.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm.adviserName.length
                                ? _c(
                                    "p",
                                    { staticClass: "m-left-10 mt-10 font-18" },
                                    [_vm._v(_vm._s(_vm.adviserName))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.adviserName.length
                                ? _c(
                                    "p",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.adviserNameError.length,
                                          expression: "adviserNameError.length"
                                        }
                                      ],
                                      staticClass: "error m-left-10"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.adviserNameError)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-ask textareaAfter" },
                                [
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "padding-left-10",
                                    attrs: {
                                      name: "insight",
                                      placeholder: "Response from advisor"
                                    },
                                    on: { input: _vm.sanitizeResponseInsight },
                                    model: {
                                      value: _vm.responseInsight,
                                      callback: function($$v) {
                                        _vm.responseInsight = $$v
                                      },
                                      expression: "responseInsight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("insight"),
                                      expression: "errors.has('insight')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("insight")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-ask" },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-accent md-raised upper-word md-white-color",
                                      attrs: { type: "submit" }
                                    },
                                    [
                                      _vm._v(
                                        "Add\n\t\t\t\t\t\t\t\t\t\tResponse"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ask-feedback",
        {
          staticClass: "mt-30",
          attrs: {
            id: "requestFeedback",
            ask: _vm.ask,
            feedbacks: _vm.feedbacks
          }
        },
        [_vm._v("Feedback goes\n\t\t\there...")]
      ),
      _vm._v(" "),
      _c(
        "comments",
        { staticClass: "mt-30", attrs: { ask: _vm.ask, section: "Comments" } },
        [_vm._v("Activity log goes here...")]
      ),
      _vm._v(" "),
      _c("email-log", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Email log goes here...")
      ]),
      _vm._v(" "),
      _c(
        "activity-log",
        {
          staticClass: "mt-30",
          attrs: { ask: _vm.ask, analysis: _vm.ask.analysis }
        },
        [_vm._v("Activity log goes here...")]
      ),
      _vm._v(" "),
      _c("coach-log", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Coach logs go here...")
      ]),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticClass: "eval-modal",
          attrs: { "md-active": _vm.evalModalOpen },
          on: {
            "update:mdActive": function($event) {
              _vm.evalModalOpen = $event
            },
            "update:md-active": function($event) {
              _vm.evalModalOpen = $event
            }
          }
        },
        [
          _vm.selectedEval
            ? _c("md-dialog-content", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-between",
                      "margin-bottom": "16px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "10px"
                        }
                      },
                      [
                        _c("i", {
                          class: {
                            "fa fa-check-circle":
                              _vm.selectedEval.recommended.score === "Approve",
                            "fa fa-exclamation-circle":
                              _vm.selectedEval.recommended.score ===
                              "Approve with Caution",
                            "fa fa-times-circle":
                              _vm.selectedEval.recommended.score ===
                              "Do Not Approve"
                          },
                          style: {
                            fontSize: "20px",
                            color:
                              _vm.selectedEval.recommended.score === "Approve"
                                ? "#2e7d32"
                                : _vm.selectedEval.recommended.score ===
                                  "Approve with Caution"
                                ? "#e65100"
                                : "#c62828"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "18px",
                              "font-weight": "600"
                            }
                          },
                          [_vm._v("Response Evaluation")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "8px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "approval-verdict-badge",
                            class: {
                              "verdict-approve":
                                _vm.selectedEval.recommended.score ===
                                "Approve",
                              "verdict-caution":
                                _vm.selectedEval.recommended.score ===
                                "Approve with Caution",
                              "verdict-reject":
                                _vm.selectedEval.recommended.score ===
                                "Do Not Approve"
                            },
                            staticStyle: { margin: "0" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.selectedEval.recommended.score ===
                                    "Approve"
                                    ? "PASS"
                                    : _vm.selectedEval.recommended.score ===
                                      "Approve with Caution"
                                    ? "CAUTION"
                                    : "FAIL"
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-times",
                          staticStyle: {
                            cursor: "pointer",
                            color: "#aaa",
                            "font-size": "14px"
                          },
                          on: {
                            click: function($event) {
                              _vm.evalModalOpen = false
                            }
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "eval-divider" }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "11px",
                      "font-weight": "600",
                      color: "#888",
                      "text-transform": "uppercase",
                      "letter-spacing": "0.08em",
                      margin: "12px 0 8px"
                    }
                  },
                  [_vm._v("\n\t\t\t\t\tReason")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      color: "#444",
                      "line-height": "1.6",
                      margin: "0 0 20px"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.selectedEval.summary.summary_of_results) +
                        "\n\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticStyle: {
                      width: "100%",
                      padding: "12px",
                      background: "#2196f3",
                      color: "white",
                      border: "none",
                      "border-radius": "24px",
                      "font-size": "15px",
                      "font-weight": "500",
                      cursor: "pointer"
                    },
                    on: {
                      click: function($event) {
                        _vm.evalModalOpen = false
                      }
                    }
                  },
                  [_vm._v("Close")]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4409880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4409880","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestDetail.vue
// module id = null
// module chunks = 